import axios from 'axios';
import { logout, refreshToken } from './services/auth';
import { API_ROUTES } from './routes';

const API_BASE_URL = 'https://market-echo-backend.fly.dev/api';

const axiosInstance = axios.create({
	baseURL: API_BASE_URL,
	timeout: 10000, // 10 seconds timeout
	headers: {
		'Content-Type': 'application/json',
	},
});

// Request Interceptor
axiosInstance.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem('accessToken');
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => Promise.reject(error)
);

// Response Interceptor
axiosInstance.interceptors.response.use(
	(response) => response,
	async (error) => {
		const originalRequest = error.config;

		if (
			error.response?.status === 401 &&
			originalRequest.url === API_ROUTES.refresh
		) {
			logout();
			return Promise.reject(error);
		}

		if (error.response?.status === 401 && !originalRequest._retry) {
			originalRequest._retry = true; // Mark the request as retried

			try {
				const newAccessToken = await refreshToken();

				axiosInstance.defaults.headers.common[
					'Authorization'
				] = `Bearer ${newAccessToken}`;
				originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;

				return axiosInstance(originalRequest);
			} catch (refreshError) {
				console.error('Token refresh failed:', refreshError);
				return Promise.reject(refreshError);
			}
		}

		return Promise.reject(error);
	}
);

export default axiosInstance;
